
define("json!shoptheme/etc/consent.json", function(){ return {
  	"youtube": "BJz7qNsdj-7",
  	"vimeo": "HyEX5Nidi-m"
};});

